import { TableMapping } from "@made-people/centra-checkout-api";
import { getGlobalItemSize } from "./get-global-item-size";

export function parseWarehouseStatus(
  jsonString: string | null,
  sizeLabel: string,
  tableMapping: TableMapping,
): string | null {
  if (!jsonString) {
    return null;
  }

  try {
    const parsed = JSON.parse(jsonString);
    const globalSizeLabel = getGlobalItemSize(sizeLabel, tableMapping);

    if (typeof globalSizeLabel !== "string") {
      return null;
    }

    if (globalSizeLabel in parsed) {
      return parsed[globalSizeLabel] ?? null;
    }

    const normalized = globalSizeLabel.replace(/\s+/g, "x");
    const parts = normalized.split("x");

    if (parts.length >= 2) {
      const [sizePart, letterPart] = parts;
      const sizeNum = parseInt(sizePart, 10);

      if (!isNaN(sizeNum) && letterPart) {
        const key = `${sizePart.padStart(3, "0")}x${letterPart.toUpperCase()}`;
        return parsed[key] ?? null;
      }
    }

    if (parts.length === 1) {
      return parsed[globalSizeLabel] ?? null;
    }

    return null;
  } catch (err) {
    return null;
  }
}

export function isWeeksStatus(status: string | null): boolean {
  return !!status && /^W(([1-4][0-9]?)|(5[0-3])|([1-9]))$/.test(status.trim());
}
